module.exports = __webpack_public_path__ + "static/img/prq5.fc43a4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq5.jpg
// module id = MuGg
// module chunks = 2